/**
 * Returns true if the application is running in Vite's local development server mode.
 */
export function isDevMode(): boolean {
  return (
    typeof import.meta.env !== "undefined" &&
    import.meta.env.MODE === "development"
  );
}
